import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../data/images';
import { ritualSteps } from '../data/ritual';
import { products } from '../data/products';
import { useSeo } from '../hooks/useSeo';
export function About() {
  useSeo({
    title: 'Over AMIRA Beauty – Traditionele Marokkaanse verzorging in 9 stappen',
    description: 'Het verhaal achter AMIRA Beauty: pure verzorging uit Aït Baha, Marokko. Ontdek het traditionele hammam-ritueel in 9 stappen, met de juiste producten per stap.',
    path: '/over-amira',
    image: images.ritual
  });
  return <>
      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-20" data-id="element-534" data-mp="2samqzxuvjfxv">
        <div className="flex flex-col justify-center lg:col-span-6" data-id="element-535" data-mp="2x8eu7o0yyohd">
          <h1 className="font-display text-4xl uppercase leading-[0.95] tracking-display sm:text-6xl" data-id="element-536" data-mp="1guy75fcx2x1a">
            Terug naar <em className="italic text-pink" data-id="element-537" data-mp="1lukitkd3k57z">de basis</em>
          </h1>
          <div className="mt-8 space-y-5 text-lg leading-relaxed text-muted" data-id="element-538" data-mp="1lrolny92pkkl">
            <p data-id="element-539" data-mp="1ui1w4u5r36j5">
              Amira groeide op in Aït Baha, tussen de heuvels van de Anti-Atlas. Cosmetica bestond daar niet uit chemische producten
              uit kastjes, maar uit henna, arganolie en gedroogde planten — gemengd door haar oma.
            </p>
            <p data-id="element-540" data-mp="1yic0k2dw9ovw">
              Op de souk leerde ze de zeep, kruiden, oliën en geurende waters kennen. Later zag ze diezelfde ingrediënten terug in
              hedendaagse beautyproducten, verpakt in grote verhalen en grote beloftes.
            </p>
            <p className="text-ink" data-id="element-541" data-mp="28fqg7zrzu9n5">
              Een product hoef je niet mooier te maken dan het is. Je moet weten wat het is, wat het doet en hoe je het gebruikt.
            </p>
          </div>
        </div>
        <img src={images.story} alt="Twee generaties mengen henna in een terracotta schaal" className="aspect-[4/5] w-full rounded-3xl object-cover lg:col-span-6" data-id="element-542" data-mp="2w75e9gcqm4sl" />
      </section>

      <section id="ritueel" className="bg-surface" data-id="element-543" data-mp="2r5y6vieib7mg">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-24" data-id="element-544" data-mp="1ovo3w82sip82">
          <div className="lg:col-span-5" data-id="element-545" data-mp="1sx1bonpg12hm">
            <div className="lg:sticky lg:top-24" data-id="element-546" data-mp="1stvndaon24my">
              <h2 className="font-display text-3xl uppercase leading-[0.98] tracking-display sm:text-5xl" data-id="element-547" data-mp="1xuj9bhy0fvab">Traditionele verzorging in 9 stappen</h2>
              <p className="mt-4 text-lg text-muted" data-id="element-548" data-mp="22nvu1gzkjhxs">Geïnspireerd op de hammam. Elke stap heeft een doel en een product dat precies dat doet.</p>
              <Link to="/product/hammam-ritueel-set" className="mt-8 inline-flex h-14 items-center whitespace-nowrap rounded-full bg-ink px-7 text-base font-medium text-white transition-colors duration-150 hover:bg-berry" data-id="element-549" data-mp="2cj614j4tqfif">
                Shop de Hammam Ritueel Set
              </Link>
            </div>
          </div>
          <ol className="lg:col-span-7" data-id="element-550" data-mp="r6mf97rdxe2t">
            {ritualSteps.map((s, i) => <li key={s.title} className="grid grid-cols-[3rem_1fr] gap-4 border-t border-line py-6 last:border-b" data-id="element-551" data-mp="r8pd2dys4bi3" data-mpi={i}>
                <span className="font-display text-2xl text-pink tabular-nums" data-id="element-552" data-mp="ewwr9r3bnnpt">{i + 1}</span>
                <div data-id="element-553" data-mp="9xaetjvbibi2">
                  <h3 className="text-xl font-semibold tracking-tight" data-id="element-554" data-mp="9wsb626bsv04">{s.title}</h3>
                  <p className="mt-1 text-muted" data-id="element-555" data-mp="4yz4z950w0zu">{s.text}</p>
                  {s.products.length > 0 && <ul className="mt-3 flex flex-wrap gap-2" data-id="element-556" data-mp="12mhc6fj1cv1q">
                      {s.products.map(name => {
                  const p = products.find(x => x.name === name);
                  if (!p) return null;
                  return <li key={name} data-id="element-557" data-mp="spw39j3wazsm">
                            <Link to={`/product/${p.slug}`} className="flex items-center gap-2 rounded-full border border-line bg-white py-1 pl-1 pr-3 text-sm transition-colors duration-150 hover:border-pink hover:text-pink" data-id="element-558" data-mp="oleo5x8hdao6">
                              <img src={p.image} alt="" className="h-6 w-6 rounded-full object-cover" data-id="element-559" data-mp="1137dq2c6qarc" />
                              {p.name}
                            </Link>
                          </li>;
                })}
                    </ul>}
                </div>
              </li>)}
          </ol>
        </div>
      </section>
    </>;
}